import styled from "styled-components";

export const ViewProjectsSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;
  .create-projects {
    align-self: flex-end;
  }
  .projects-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 10px;
    margin: 1rem;
  }
  .projects-cards {
    margin: 0.8rem;
  }
  .projects-cards:hover {
    box-shadow: 0 5px 10px pink;
    cursor: pointer;
  }
`;
